export default {
  heatmapSeries: [],
  heatmapKey: 'unloaded',
  heatmapOptions: [],
  clusterOptions: null,
}
